"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _core = require("@aws-amplify/core");
var _auth = require("aws-amplify/auth");
var _config = _interopRequireDefault(require("./config"));
var _clearCredentials = _interopRequireDefault(require("@xto10x/oauth2/lib/clearCredentials"));
var _utils = require("aws-amplify/utils");
var _cognito = require("aws-amplify/auth/cognito");
_core.Amplify.configure({
  Auth: {
    Cognito: {
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: _config["default"].identityPoolId,
      // REQUIRED - Amazon Cognito Region
      region: _config["default"].region,
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: _config["default"].userPoolId,
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId: _config["default"].userPoolWebClientId,
      loginWith: {
        oauth: {
          domain: _config["default"].authDomain,
          scopes: ['email', 'openid'],
          redirectSignIn: ["".concat(_config["default"].loginUrl, "/oauthcallback")],
          redirectSignOut: ["".concat(_config["default"].loginUrl)],
          responseType: 'code'
        }
      }
    }
  },
  Storage: {
    AWSS3: {
      bucket: _config["default"].s3Bucket,
      region: _config["default"].region
    }
  }
});
_cognito.cognitoUserPoolsTokenProvider.setKeyValueStorage(new _utils.CookieStorage({
  domain: _config["default"].cookieDomain
}));
var auth = {
  signUp: function signUp(name, email, password) {
    var sign_up_source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'email';
    if (name == null) return Promise.reject(new Error('Invalid name'));
    name = name.replace(/[^a-zA-Z ]/g, ' ').trim();
    return (0, _auth.signUp)({
      username: email,
      password: password,
      options: {
        userAttributes: {
          email: email,
          name: name,
          'custom:sign_up_source': sign_up_source
        }
      }
    });
  },
  confirmSignUp: function confirmSignUp(username, password, verificationCode) {
    var autoSignIn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var confirmSignUpPromise = (0, _auth.confirmSignUp)({
      username: username,
      confirmationCode: verificationCode,
      options: {
        forceAliasCreation: true
      }
    });
    if (autoSignIn) {
      return confirmSignUpPromise.then(function () {
        return (0, _auth.signIn)({
          username: username,
          password: password
        });
      });
    }
    return confirmSignUpPromise;
  },
  resendSignUpCode: function (_resendSignUpCode) {
    function resendSignUpCode(_x) {
      return _resendSignUpCode.apply(this, arguments);
    }
    resendSignUpCode.toString = function () {
      return _resendSignUpCode.toString();
    };
    return resendSignUpCode;
  }(function (username) {
    return resendSignUpCode({
      username: username
    });
  }),
  signIn: function signIn(username, password) {
    return (0, _auth.signIn)({
      username: username,
      password: password
    });
  },
  googleSignIn: function googleSignIn(token, expires_in) {
    var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return (0, _auth.signInWithRedirect)({
      provider: {
        custom: 'Google'
      },
      options: {
        token: token,
        expires_at: expires_in + new Date().getTime()
      },
      user: user
    });
  },
  federatedSignIn: function federatedSignIn(provider) {
    return (0, _auth.signInWithRedirect)({
      provider: {
        custom: provider
      }
    });
  },
  userWithEmailExist: function userWithEmailExist(email) {
    var code = '000000';
    return (0, _auth.confirmSignUp)({
      username: email,
      confirmationCode: code,
      options: {
        forceAliasCreation: false
      }
    }).then(function () {
      return true;
    })["catch"](function (err) {
      switch (err.name) {
        case 'UserNotFoundException':
        case 'LimitExceededException':
          return false;
        default:
          return true;
      }
    });
  },
  signOut: function signOut() {
    _clearCredentials["default"].all();
    return (0, _auth.signOut)();
  },
  changePassword: function () {
    var _changePassword = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(oldPassword, newPassword) {
      var user;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return (0, _auth.getCurrentUser)();
          case 1:
            user = _context.sent;
            return _context.abrupt("return", updatePassword({
              oldPassword: oldPassword,
              newPassword: newPassword
            }).then(function () {
              return (0, _auth.signOut)({
                global: true
              });
            }).then(function () {
              return (0, _auth.signIn)({
                username: user.username,
                password: newPassword
              });
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function changePassword(_x2, _x3) {
      return _changePassword.apply(this, arguments);
    }
    return changePassword;
  }(),
  forgotPassword: function forgotPassword(username) {
    return (0, _auth.resetPassword)({
      username: username
    });
  },
  forgotPasswordSubmit: function forgotPasswordSubmit(username, code, newPassword) {
    return (0, _auth.confirmResetPassword)({
      username: username,
      confirmationCode: code,
      newPassword: newPassword
    });
  },
  currentAuthenticatedUser: function currentAuthenticatedUser() {
    var bypassCache = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (0, _auth.getCurrentUser)({
      bypassCache: bypassCache
    });
  },
  currentSession: function currentSession() {
    return (0, _auth.fetchAuthSession)();
  },
  currentCredentials: function currentCredentials() {
    return (0, _auth.currentCredentials)();
  },
  currentUserCredentials: function currentUserCredentials() {
    return (0, _auth.fetchAuthSession)();
  },
  userAttributes: function userAttributes() {
    return (0, _auth.fetchUserAttributes)();
  },
  updateUserName: function () {
    var _updateUserName = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(name) {
      var user;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(name == null)) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return", Promise.reject(new Error('Invalid name')));
          case 1:
            name = name.replace(/[^a-zA-Z ]/g, ' ').trim();
            _context2.next = 2;
            return (0, _auth.getCurrentUser)();
          case 2:
            user = _context2.sent;
            return _context2.abrupt("return", (0, _auth.updateUserAttributes)({
              userAttributes: {
                username: name
              }
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function updateUserName(_x4) {
      return _updateUserName.apply(this, arguments);
    }
    return updateUserName;
  }(),
  updateUserPicture: function () {
    var _updateUserPicture = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(picture) {
      var user;
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 1;
            return (0, _auth.getCurrentUser)();
          case 1:
            user = _context3.sent;
            return _context3.abrupt("return", (0, _auth.updateUserAttributes)({
              userAttributes: {
                picture: picture
              }
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function updateUserPicture(_x5) {
      return _updateUserPicture.apply(this, arguments);
    }
    return updateUserPicture;
  }()
};
var _default = exports["default"] = auth;